import React from 'react'

import { withSetCarBookmark } from './../../../shared/containers/containerSetCarBookmark'
import { withDeleteCarBookmark } from './../../../shared/containers/containerDeleteCarBookmark'

import Icon from './../../../shared/items/static/icon'

import styles from './carsBookmark.module.scss'

const CarsBookmark = props => {
  const { isBookmark, carId, onSetCarBookmark, onDeleteCarBookmark } = props

  return (
    <div className={styles.carsBookmark} onClick={!isBookmark ? onSetCarBookmark.bind(this, carId) : onDeleteCarBookmark.bind(this, carId)}>
      <Icon name="fav1" />
    </div>
  )
}

export default withDeleteCarBookmark(withSetCarBookmark(React.memo(CarsBookmark)))